import React from 'react';
import {
  ChakraProvider,
  extendTheme
} from '@chakra-ui/react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import CV1Metrics from './components/CV1Metrics'
import CV2Metrics from './components/CV2Metrics'
import NotAllowed from './components/NotAllowed'

const theme = extendTheme({
  colors: {
    brand: {
      100: "#59595A",
      900: "#C02033",
    },
  },
  components: {
    Radio: {
      parts: ['label'],
      baseStyle: {
        label: {
          _checked: {
            fontWeight: 'bold'
          }
        },
      },
    },
    Select: {
      baseStyle: {
        field: {
          fontWeight: 'bold'
        },
        icon: {
          // base styles for the icon go here
        }
      },
    }
  }
})

const App = () => {
  const wipProtectionToken = '97e8ea9a-01e7-4c68-8f3b-173d79dc2960';
  return (
    <ChakraProvider theme={theme}>
      <Router>
        <Routes>
          <Route path={`/${wipProtectionToken}`} element={ <CV1Metrics/> } />
          <Route path={`/cv2`} element={ <CV2Metrics/> } />
          <Route path="*" element={ <NotAllowed/> } />
        </Routes>
      </Router>
    </ChakraProvider>
  );
}

export default App;